import columns from '../../../../../../react-table/helpers/columns';

// UPU code list 108 IMPC functions that are valid for PREDES usage.
// Any other function is an error (bold red); N is a warning (bold amber).
export const VALID_IMPC_FUNCTIONS = ['O', 'B', 'M'];

const impcFunctionConditionalProps = accessor => (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    const impcFunction = rowInfo.row[accessor];
    if (impcFunction === 'N') {
      className = 'bg-orange-amber-bold';
    } else if (impcFunction && VALID_IMPC_FUNCTIONS.indexOf(impcFunction) === -1) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const originImpcFunctionConditionalProps = impcFunctionConditionalProps('originImpc.function');

export const destinationImpcFunctionConditionalProps = impcFunctionConditionalProps('destinationImpc.function');

export const detailsColumnsConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['originImpc.mailFlow'] === 'I' || rowInfo.row['destinationImpc.mailFlow'] === 'E') {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const despatchClosedConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo && (rowInfo.row['originImpc.validFrom'] !== 0) && (rowInfo.row['originImpc.validTo'] !== 0) && (rowInfo.row['destinationImpc.validFrom'] !== 0) && (rowInfo.row['destinationImpc.validTo'] !== 0)) {
    if (!((rowInfo.row['originImpc.validFrom'] <= parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) && parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) <= rowInfo.row['originImpc.validTo']) && (rowInfo.row['destinationImpc.validFrom'] <= parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) && parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) <= rowInfo.row['destinationImpc.validTo']))) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const originDespatchClosedConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo && (rowInfo.row['originImpc.validFrom'] !== 0) && (rowInfo.row['originImpc.validTo'] !== 0)) {
    if (!(rowInfo.row['originImpc.validFrom'] <= parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) && parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) <= rowInfo.row['originImpc.validTo'])) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const destinationDespatchClosedConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo && (rowInfo.row['destinationImpc.validFrom'] !== 0) && (rowInfo.row['destinationImpc.validTo'] !== 0)) {
    if (!(rowInfo.row['destinationImpc.validFrom'] <= parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) && parseInt(rowInfo.row['usage.despatchCloseDate'].replace(/-/g, ''), 0) <= rowInfo.row['destinationImpc.validTo'])) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const mailCategoryConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo.row['originImpc.mailCategory'] !== null && rowInfo.row['destinationImpc.mailCategory'] !== null) {
    if (rowInfo.row['originImpc.mailCategory'].split(' ').indexOf(rowInfo.row['usage.mailCategory']) === -1 || rowInfo.row['destinationImpc.mailCategory'].split(' ').indexOf(rowInfo.row['usage.mailCategory']) === -1) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const mailClassConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo.row['originImpc.mailClass'] !== null && rowInfo.row['destinationImpc.mailClass'] !== null) {
    if (rowInfo.row['originImpc.mailClass'].split(' ').indexOf(rowInfo.row['usage.mailClass']) === -1 || rowInfo.row['destinationImpc.mailClass'].split(' ').indexOf(rowInfo.row['usage.mailClass']) === -1) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const originMailCategoryConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo.row['originImpc.mailCategory'] !== null) {
    if (rowInfo.row['originImpc.mailCategory'].split(' ').indexOf(rowInfo.row['usage.mailCategory']) === -1) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const destinationMailCategoryConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo.row['destinationImpc.mailCategory'] !== null) {
    if (rowInfo.row['destinationImpc.mailCategory'].split(' ').indexOf(rowInfo.row['usage.mailCategory']) === -1) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const originMailClassConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo.row['originImpc.mailClass'] !== null) {
    if (rowInfo.row['originImpc.mailClass'].split(' ').indexOf(rowInfo.row['usage.mailClass']) === -1) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export const destinationMailClassConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo.row['destinationImpc.mailClass'] !== null) {
    if (rowInfo.row['destinationImpc.mailClass'].split(' ').indexOf(rowInfo.row['usage.mailClass']) === -1) {
      className = 'bg-red-bold';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'Usage',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'usage.despatchId').withWidth(220)),
        new DateTimeColumn('Despatch closed', 'usage.despatchCloseDate').withGetProps(despatchClosedConditionalProps),
        new TextColumn('Mail category', 'usage.mailCategory').withGetProps(mailCategoryConditionalProps),
        new TextColumn('Mail class', 'usage.mailClass').withGetProps(mailClassConditionalProps),
      ],
    },
    {
      Header: 'Code list 108 Attributes - Origin IMPC',
      columns: [
        new TextColumn('Function', 'originImpc.function').withGetProps(originImpcFunctionConditionalProps),
        new NonZeroNumberColumn('Valid from', 'originImpc.validFrom').withGetProps(originDespatchClosedConditionalProps),
        new NonZeroNumberColumn('Valid to', 'originImpc.validTo').withGetProps(originDespatchClosedConditionalProps),
        new TextColumn('Mail flow', 'originImpc.mailFlow').withGetProps(detailsColumnsConditionalProps),
        new TextColumn('Mail category', 'originImpc.mailCategory').withGetProps(originMailCategoryConditionalProps),
        new TextColumn('Mail class', 'originImpc.mailClass').withGetProps(originMailClassConditionalProps),
      ],
    },
    {
      Header: 'Code list 108 Attributes - Destination IMPC',
      columns: [
        new TextColumn('Function', 'destinationImpc.function').withGetProps(destinationImpcFunctionConditionalProps),
        new NonZeroNumberColumn('Valid from', 'destinationImpc.validFrom').withGetProps(destinationDespatchClosedConditionalProps),
        new NonZeroNumberColumn('Valid to', 'destinationImpc.validTo').withGetProps(destinationDespatchClosedConditionalProps),
        new TextColumn('Mail flow', 'destinationImpc.mailFlow').withGetProps(detailsColumnsConditionalProps),
        new TextColumn('Mail category', 'destinationImpc.mailCategory').withGetProps(destinationMailCategoryConditionalProps),
        new TextColumn('Mail class', 'destinationImpc.mailClass').withGetProps(destinationMailClassConditionalProps),
      ],
    },
  ];
};
